import { Box, HStack } from "@chakra-ui/react";
import React from "react";
import { useContext } from "react";
import { SmoothScrollLink } from "components/atoms/SmoothScroll";
import { NavigationPageSpacer } from "components";
import { Container } from "components";
import { IProduct } from "interfaces/product.interface";

const ProductNavigationContext = React.createContext<any>({
  color: "primary",
});

const useProductNavigationContext = () => useContext(ProductNavigationContext);

const ProductNavigationLink = ({ children }: any) => {
  const { color } = useProductNavigationContext();

  return (
    <Box
      cursor="pointer"
      fontWeight={500}
      color="gray.900"
      _hover={{
        color: `${color}.500`,
      }}
    >
      {children}
    </Box>
  );
};

export const ProductNavigation = ({
  product,
  links,
  isSticky,
}: {
  product: IProduct;
  links: any;
  isSticky: boolean;
}) => {
  const { name, color, icon } = product;

  return (
    <ProductNavigationContext.Provider
      value={{
        name,
        color,
      }}
    >
      <Box position="relative">
        <NavigationPageSpacer />
        <Box
          width="100%"
          top={0}
          height={20}
          zIndex={1}
          borderBottom={isSticky && "1px solid"}
          borderColor="gray.150"
        >
          <Container height="100%">
            <Box
              display="flex"
              alignItems="center"
              h="100%"
              borderColor="gray.100"
            >
              <Box display="flex" alignItems="center">
                <Box color={`${color}.500`} fontWeight={600} fontSize="md">
                  {name}
                </Box>
              </Box>
              <Box display="flex" ml="auto">
                <HStack spacing={{ base: 4, lg: 6 }}>
                  {links &&
                    links.map((link, i: number) => {
                      return (
                        <SmoothScrollLink to={link.to} key={i}>
                          <ProductNavigationLink>
                            {link.label}
                          </ProductNavigationLink>
                        </SmoothScrollLink>
                      );
                    })}
                </HStack>
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
    </ProductNavigationContext.Provider>
  );
};
